<template>
  <div v-if="isTrustpilotDataLoaded" class="trustpilot-section ws-grid">
    <div class="trustpilot-section__content ws-col-6-gte600 ws-col-10-gte960">
      <section-title :title="$t('trustpilot.section.title')" class="trustpilot-section__title" />
      <reviews-slider :reviews="trustpilotReviews" />
      <trust-box
        class="trustpilot-section__score"
        :reviews-number="trustpilotData.numberOfReviews"
        :total-score="trustpilotData.totalScore"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import ReviewsSlider from '@/components/trustpilot-section/ReviewsSlider.vue';
import TrustBox from '@/components/trustpilot-section/TrustBox.vue';
import SectionTitle from '@/components/common/SectionTitle.vue';

import { types } from '@/store/types';

export default {
  name: 'TrustpilotSection',
  components: {
    ReviewsSlider,
    TrustBox,
    SectionTitle
  },
  data() {
    return {
      reviews: [],
      numberOfReviews: 0,
      totalScore: 0,
      isTrustpilotDataLoaded: false
    };
  },
  computed: {
    ...mapState({
      locale: types.state.LOCALE,
      trustpilotData: types.state.TRUSTPILOT_DATA,
      trustpilotReviews: types.state.TRUSTPILOT_REVIEWS
    })
  },
  watch: {
    locale() {
      this.getTrustpilotInfo();
    }
  },
  async mounted() {
    if (this.trustpilotData && this.trustpilotReviews.length) {
      this.isTrustpilotDataLoaded = true;

      return;
    }

    await this.getTrustpilotInfo();

    this.isTrustpilotDataLoaded = true;
  },
  methods: {
    ...mapActions({
      getTrustpilotData: types.actions.GET_TRUSTPILOT_DATA,
      getTrustpilotReviews: types.actions.GET_TRUSTPILOT_REVIEWS
    }),
    async getTrustpilotInfo() {
      await Promise.all([this.getTrustpilotData(), this.getTrustpilotReviews()]);
    }
  }
};
</script>

<style lang="scss" scoped>
.trustpilot-section {
  padding: 56px var(--ws-grid-m, 16px) 20px;

  &__content {
    margin: 0 auto;
  }

  &__title {
    margin-bottom: 42px;
  }
}

@media (min-width: 360px) {
  .trustpilot-section {
    padding: 70px var(--ws-grid-m, 16px) 20px;
  }
}

@media (min-width: 960px) {
  .trustpilot-section {
    padding: 120px var(--ws-grid-m) 20px;

    &__title {
      margin-bottom: 64px;
      text-align: center;
    }

    &__score {
      width: fit-content;
      margin: 64px auto 0;
    }
  }
}
</style>
